
import React, {useEffect,useState} from 'react';
import Pagination from "react-js-pagination";
import Cookies from "universal-cookie";
import axios from "axios";
import Host from "../../../assets/js/Host";
import { toast } from 'react-toastify';
import { Button } from 'react-bootstrap';
import RoleForm from './RoleForm';
import {useSelector,useDispatch} from 'react-redux'
import Grid from '../Share/Grid'
import DialogForm from '../Share/DialogForm';


import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import IconButton from "@material-ui/core/IconButton";
import {useTranslation} from "react-i18next";

const cookies = new Cookies();
const token = cookies.get("token")
const language = cookies.get("language")?cookies.get("language"):"ar"
function Role() {
    const [t, i18n] = useTranslation('common');

    const [loading, setloading] = useState(false);
    const [state, setData] = useState({
        roles: ''
    });
    const [showRoleForm, setshowRoleForm] = useState(false);
    const [selectedRole, setselectedRole] = useState(null);

    const [pageSize, setPageSize] = useState(5);
    const [pageNumber, setpageNumber] = useState(1);
    const [pointsTotal, setPointsTotal] = useState(0)
    const [pointsNumberOfPages, setPointsNumberOfPages] = useState(0)
    const directions = useSelector(state => state.settingsData.directions)
    const [rows, setRow] = useState([])

    const handlePageChange = (newPage) => {
        setpageNumber(newPage + 1)
    }

    const columns = [
        { field: 'id', headerName: t('ROLES.ID'), flex: .1 },
        {
            field: 'role_name', headerName: t('ROLES.ROLE_NAME'), flex: 2,
            renderCell: (rows) => (
                <div style={{ width: '100%' }} className={`${directions =='rtl'?'alignColumnRight':'alignColumnLeft'}`}>
                    {rows.row?.name}
                </div>
            )
        },
        {
            field: 'actions', flex: 1,
            headerName: t('ROLES.ACTIONS'),
            renderCell: (rows) => (
                <strong className={`${directions =='rtl'?'alignColumnRight':'alignColumnLeft'}`}>
                    <IconButton
                        size="small"
                        style={{ marginLeft: 0 }}
                        onClick={() => {
                            updateObject(rows.row)
                        }}>
                        <Tooltip title={directions =='rtl'?'تعديل':'edit'}>
                            <EditIcon style={{ fill: "#111827" }} />
                        </Tooltip>
                    </IconButton>

                    <IconButton
                        style={{ marginLeft: 15 }}
                        aria-label="view"
                        size="small"
                        onClick={() => {
                            deleteObject(rows.row)
                            // previewObject(rows.row.object1)
                        }}>
                        <Tooltip title={directions =='rtl'?'تعديل':'edit'}>
                            <DeleteIcon style={{ fill: "#f00" }} />
                        </Tooltip>
                    </IconButton>
                </strong>
            ),
        },
    ]

  


    const fetchData = async (pageNumber = 1) => {
        setloading(true)
        try {
            const result=await axios({
                url: Host + "roles?page="+pageNumber,
                method: "get",
                headers: {
                "Authorization" : `Bearer ${token}`,
                    Accept:"application/json",
                    'X-localization':language,
                }
        
            })
            if(result && result.status == 200)
            {
                const roles=result.data ;
                
                console.log(roles);
                setData({
                    roles:roles 
                });
            } else if (result.data.status === false) {
                toast.error("Error")
            }
        } catch (error) {
            const responseResult=error.response            
            if (responseResult && responseResult.status === 400) {
                if(typeof responseResult.data.data === "object")
                {
                    const errorMessagesKeys = Object.keys(responseResult.data.data);
                    errorMessagesKeys.map((key)=>{
                    
                        responseResult.data.data[key].map((message)=>{
                            toast.error(message)
                        })
                    })
                }
                else{
                    toast.error(responseResult.data.data)
                }
                
            }
            else if(responseResult && responseResult.status === 401) {
                toast.error(responseResult.data.data)
                cookies.remove("token");
                window.location.href = "/"
            }
            else
            {
                toast.error("network error")
            }
        }
        setloading(false)
                   
    };
    const updateObject = async (object) => {
      
        console.log("hi");
        setselectedRole(object)
        setshowRoleForm(true)
    };
    const deleteObject = async (object) => {
        if (!window.confirm("Delete the item?")) {
            return
        }
        setloading(true)
        try {
            const result=await axios({
                url: Host + "roles/"+object.id,
                method: "delete",
                headers: {
                "Authorization" : `Bearer ${token}`,
                    Accept:"application/json",
                    'X-localization':language,
                }
        
            })
            if(result && result.status == 200)
            {
                toast.error(result.data.data)
                fetchData();
            } else if (result.data.status === false) {
                toast.error("Error")
            }
        } catch (error) {
            const responseResult=error.response            
            if (responseResult && responseResult.status === 400) {
                if(typeof responseResult.data.data === "object")
                {
                    const errorMessagesKeys = Object.keys(responseResult.data.data);
                    errorMessagesKeys.map((key)=>{
                    
                        responseResult.data.data[key].map((message)=>{
                            toast.error(message)
                        })
                    })
                }
                else{
                    toast.error(responseResult.data.data)
                }
                
            }
            else if(responseResult && responseResult.status === 401) {
                toast.error(responseResult.data.data)
                cookies.remove("token");
                window.location.href = "/"
            }
            else
            {
                toast.error("network error")
            }
        }
        setloading(false)
    };
    
    const createObject = async (object) => {
        setselectedRole(null)
        setshowRoleForm(true)
    };

    const handleSetshowRoleForm = (openStatus,needsReload) => {
      if(needsReload)
      fetchData();
      setshowRoleForm(openStatus)
    };
    
    
    useEffect(() => {        
        fetchData(pageNumber);
    }, [pageNumber])

    useEffect(() => {
        if (state && state.roles&&state.roles?.data?.length > 0) {
            setRow(state?.roles?.data);
            setPointsTotal(state?.roles?.total)
            setPointsNumberOfPages(state?.roles?.last_page)
        }
    }, [state])
    
    return (
        <>
            {showRoleForm?
                <RoleForm role={selectedRole} showRoleForm={showRoleForm} setshowRoleForm={handleSetshowRoleForm} />
            :null}
       

            <Grid
              rows={rows}
              columns={columns}
              rowTotals={pointsTotal}
              pageSize={pageSize}
              setPageSize={setPageSize}
              pageNumber={pageNumber}
              setPageNumber={setpageNumber}
              loading={loading}
              handlePageChange={handlePageChange}
              NumberOfPage={pointsNumberOfPages}
              directions={directions}
              hasCreate={true}
              createObject={createObject}
              title={t('ROLES.TITLE')}
            //   title_ar="قائمة الصلاحيات"
              gridHeight={{
                height:rows?.length>5?pageSize==5?400:pageSize==10?650:950:400,
              }}
            />
        </>
    );
}

export default Role;



// <div className="container">
// <div className="row justify-content-center">
//     <div className="col-md-12">
//         <div className="card">
//             <div className="card-header">Role List <Button style={{float:'right'}} onClick={()=>{createObject()}}>create</Button></div>
//             <div className="card-body">
//             <table>
//                 <thead>
//                     <tr>
//                         <th>1</th>
//                         <th>Role Name</th>
//                         <th>edit</th>
//                         <th>delete</th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                 {   
//                     state?.roles?.data ? 
//                         state?.roles?.data?.map((object) => (
//                                 <tr key={object?.id}>
//                                     <td>{object?.id}</td>
//                                     <td>{object?.name}</td>
//                                     <td><Button onClick={()=>{updateObject(object)}}>update</Button></td>
//                                     <td><Button style={{backgroundColor:'red',color:'white'}} onClick={()=>{deleteObject(object)}}>delete</Button></td>
                                    
//                                 </tr>
//                         )) : "Loading..."
//                 }
//                 </tbody>
//             </table>
//                 <div>
//                     <Pagination
//                         activePage={state?.roles?.current_page ? state?.roles?.current_page : 0}
//                         itemsCountPerPage={state?.roles?.per_page ? state?.roles?.per_page : 0 }
//                         totalItemsCount={state?.roles?.total ? state?.roles?.total : 0}
//                         onChange={(pageNumber) => {
//                             fetchData(pageNumber)
//                         }}
//                         pageRangeDisplayed={8}
//                         itemClass="page-item"
//                         linkClass="page-link"
//                         firstPageText="First Page"
//                         lastPageText="Last Lage"
//                     />
//                 </div>
//             </div>
//         </div>
//     </div>
// </div>
// </div>

